const WIDTH = 1_280;
const HORIZON_Y = 255;
const CAMERA_Y = 690;

export type RoadProjectionInput = {
  cameraDistance: number;
  relativeDistance: number;
  lane: number;
};

export type RoadPoint = {
  x: number;
  y: number;
  scale: number;
  rotation: number;
};

export function roadCenterX(distance: number): number {
  return WIDTH / 2
    + Math.sin(distance / 620) * 62
    + Math.sin(distance / 1_730 + 0.8) * 28;
}

export function roadHalfWidth(y: number): number {
  const depth = Math.max(0, Math.min(1, (y - HORIZON_Y) / (CAMERA_Y - HORIZON_Y)));
  return 72 + Math.pow(depth, 1.15) * 515;
}

export function roadRotation(distance: number): number {
  const tangent = Math.cos(distance / 620) * 62 / 620
    + Math.cos(distance / 1_730 + 0.8) * 28 / 1_730;
  return Math.max(-Math.PI / 45, Math.min(Math.PI / 45, tangent * 0.48));
}

export function projectRoadPoint({ cameraDistance, relativeDistance, lane }: RoadProjectionInput): RoadPoint {
  const y = Math.max(285, Math.min(688, 612 - relativeDistance * 2.05));
  const projectedDistance = cameraDistance + relativeDistance;
  const centerX = roadCenterX(projectedDistance);
  const laneX = Math.max(-1.15, Math.min(1.15, lane)) * roadHalfWidth(y) * 0.48;
  const depth = Math.max(0, Math.min(1, (y - HORIZON_Y) / (CAMERA_Y - HORIZON_Y)));
  return {
    x: centerX + laneX,
    y,
    scale: 0.15 + depth * 0.23,
    rotation: roadRotation(projectedDistance),
  };
}
